import './CallToAction.scss';

class CallToAction {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['CallToAction'] = CallToAction;
export default CallToAction;
